import React from 'react';

import MeasurementsUpdate from './MeasurementsUpdate';
import withModal from '../../../../../../../../modal/withModal';

export const MEASUREMENTS_UPDATE_MODAL = 'MODAL/MEASUREMENTS_UPDATE';

const MeasurementsUpdateModal = ({
  actionProps = {},
  onRequestClose,
  ...props
}) => {
  const { currentWidth, currentHeight } = actionProps;
  return (
    <MeasurementsUpdate
      currentWidth={currentWidth}
      currentHeight={currentHeight}
      onClose={onRequestClose}
      {...props}
    />
  );
};

export default withModal(MeasurementsUpdateModal, {
  name: MEASUREMENTS_UPDATE_MODAL,
  size: 'sm',
});
